export default "__VITE_ASSET__hENwNrmZ__"